import {Component} from '@angular/core'
import {faPhone} from '@fortawesome/pro-solid-svg-icons/faPhone'
import {Dialogistic} from '../../../craft/dialog/dialogistic.interface'
import {Observable, Subject} from 'rxjs'
import {I18nService} from '../../../craft/i18n/i18n.service'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {RouterModule} from '@angular/router'
import {PipesModule} from '../../pipes/pipes.module'
import {TranslocoModule} from '@ngneat/transloco'
import {CommonModule} from '@angular/common'
import {DialogModule} from '../../../craft/dialog/dialog.module'

@Component({
  selector: 'bgo-process-close-confirmation',
  templateUrl: './process-close-confirmation.component.html',
  imports: [FontAwesomeModule, RouterModule, PipesModule, TranslocoModule, CommonModule, DialogModule],
})
export class ProcessCloseConfirmationComponent implements Dialogistic<string, boolean> {
  readonly phoneIcon = faPhone
  readonly confirm: Subject<boolean> = new Subject<boolean>()

  exitButtonText!: string

  constructor(protected readonly i18nService: I18nService) {}

  close(): void {
    this.confirm.next(true)
  }

  setData(exitButtonText: string): void {
    this.exitButtonText = exitButtonText
  }

  reply$(): Observable<boolean> {
    return this.confirm.asObservable()
  }
}
